// The BE encodes "no change to this field" on partial-update ops as `null` (the generated TS
// types mark these fields optional), so both `null` and `undefined` collapse to "no change".
// An empty string is still a real change; callers that treat `""` as "no change" coerce it
// (e.g. `op.name || undefined`) before calling.
export type FieldChange<T> = { from: T; to: T };

export const diffField = <T>(current: T, next: T | null | undefined): FieldChange<T> | null => {
  if (next === null || next === undefined || next === current) {
    return null;
  }
  return { from: current, to: next };
};
